import React, { useContext, useEffect, useState } from 'react'

import { firestore } from '../../firebase'

import StateContext from '../../StateContext'
import AddFollow from './AddFollow'
import RemoveFollow from './RemoveFollow'

import './Follow.css'

function Follow({userId, userObj, isFollowing, setIsFollowing, followers, following}) {
    
    const appState = useContext(StateContext)

    
    const [followObj, setFollowObj] = useState()

    useEffect(() => {

        async function isFollowing() {
            if (appState) {
                try {
                    const followRef = firestore.collection("follow");
                    followRef
                        .where("followed_id", "==", userId)
                        .onSnapshot(({docs}) => {
                            const followers = docs.map(doc => {
                                return {id: doc.id, ...doc.data()}
                            })
                            //console.log(followers, "followers")

                            const isFollowing = followers.filter(follower => {
                                console.log(follower.follower_id, "===", appState.userId, "IS FOLLOWING OBj")
                                return follower.follower_id === appState.userId
                            })

                            
                            if (isFollowing.length > 0) {
                                setIsFollowing(true)
                                setFollowObj(isFollowing[0])
                            } else {
                                setIsFollowing(false)
                            }
                    })
                } catch (error) {
                    
                }
            }

        }
        isFollowing()


    }, [appState.userId])


    if (isFollowing && followObj && followers) {
        return (
            <RemoveFollow followers={followers} userId={userId} followObj={followObj} isFollowing={isFollowing} setIsFollowing={setIsFollowing} />
        )
    } else {
        return (
            <AddFollow following={following} userId={userId} userObj={userObj} isFollowing={isFollowing} setIsFollowing={setIsFollowing} />
        )
    }

}
export default Follow